import React from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../ducks/user.duck';
import { identifyMixpanelUser, resetMixpanelUser } from '../../util/mixpanel';

const getSharetribeUserId = currentUser =>
  currentUser?.id?.uuid || (typeof currentUser?.id === 'string' ? currentUser?.id : null);

const MixpanelIdentitySync = () => {
  const currentUser = useSelector(selectCurrentUser);
  const sharetribeUserId = getSharetribeUserId(currentUser);

  React.useEffect(() => {
    if (sharetribeUserId) {
      identifyMixpanelUser(currentUser);
      return;
    }

    resetMixpanelUser();
  }, [
    sharetribeUserId,
    currentUser?.attributes?.email,
    currentUser?.attributes?.profile?.firstName,
    currentUser?.attributes?.profile?.lastName,
    currentUser?.attributes?.profile?.displayName,
    currentUser?.attributes?.profile?.publicData?.fullName,
    currentUser?.attributes?.profile?.publicData?.signupSource,
    currentUser?.attributes?.publicData?.fullName,
    currentUser?.attributes?.publicData?.signupSource,
  ]);

  return null;
};

export default MixpanelIdentitySync;
